import {
  GET_BANK_SUCCESS,
  GET_BANK_FAILED,
  GET_BANK_INVALID_REQUEST,
  GET_BANK_NOT_FOUND,
  NETWORK_ERROR_GET_BANK,
  LOADING_GET_BANK,
  RESET_GET_BANK
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  success: false,
  invalidRequest: false,
  notFound: false,
  data: {},
  networkError: ""
};

export default (state = initialState, action) => {
  switch (action.type) {

    case LOADING_GET_BANK:
      return {
        ...state,
        isLoading: true,
        failed: false,
        success: false,
        invalidRequest: false,
        notFound: false,
        data: action.payload,
        networkError: ""
      };

    case GET_BANK_SUCCESS:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        invalidRequest: false,
        notFound: false,
        data: action.payload,
        networkError: ""
      };

    case GET_BANK_FAILED:
      return {
        ...state,
        isLoading: false,
        failed: true,
        success: false,
        invalidRequest: false,
        notFound: false,
        data: action.payload,
        networkError: ""
      };

    case GET_BANK_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        invalidRequest: true,
        notFound: false,
        data: action.payload,
        networkError: ""
      };

    case GET_BANK_NOT_FOUND:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        invalidRequest: false,
        notFound: true,
        data: action.payload,
        networkError: ""
      };

    case NETWORK_ERROR_GET_BANK:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        invalidRequest: false,
        notFound: false,
        data: action.payload,
        networkError: "OOPS.... Something went wrong !"
      };

    case RESET_GET_BANK:
      return (state = initialState);

    default:
      return state;
  }
};
